import type { RealmId } from "@chuzi/shared/types";
import { ChoiceOrbits } from "./scene-orbits";
import { WildsChoiceMotes } from "./wilds-choice-motes";

export interface RealmChoiceVisualProps {
  realm: RealmId;
  center: [number, number, number];
  hue?: number;
  /** Outgoing choice branches from the focused scene. */
  choiceIds: string[];
}

/**
 * Realm-templated decoration for branching choices around a focused atom.
 * Cosmos: orbiting planets at distinct speeds. Wilds: drifting motes.
 */
export function RealmChoiceVisual({
  realm,
  center,
  hue = 210,
  choiceIds,
}: RealmChoiceVisualProps) {
  if (choiceIds.length === 0) return null;

  if (realm === "wilds") {
    return <WildsChoiceMotes center={center} hue={hue} choiceIds={choiceIds} />;
  }

  return <ChoiceOrbits center={center} hue={hue} choiceIds={choiceIds} />;
}
